import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'card-footer', // tslint:disable-line
  template: `
    <ng-content></ng-content>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardFooterComponent {}
